import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Translate} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {connect} from "trim-redux";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {ListItem, withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Grid from "@material-ui/core/Grid/Grid";
import LoadingButton from "../../../components/elements/LoadingButton";

import EditRoundedIcon from "@material-ui/icons/EditRounded";
import TextField from "@material-ui/core/TextField/TextField";
class ExcelImportButton extends React.Component{
    state = {
        fields:{
            isbn:''
        },
        SubmitLoading:false,
        loading:false,
        open:false,
        product_id:this.props.id,
        errors:[],
    };
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({
            fields,
        });
    }
    toggleOpen(){
        this.setState({
            open: !this.state.open,
        })
    }
    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;
        if(!fields.isbn){
            formIsValid = false;
            errors['isbn'] = Translate.emptyField;
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                SubmitLoading:false,
                errors
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        const {fields,product_id} = this.state;
        let data = new FormData();
        data.append('isbn', fields.isbn);
        data.append('id', product_id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/product/add_isbn`, data, config)
            .then(response => {
                if(response.data === "ok"){
                    this.props.enqueueSnackbar(Translate.allChangesSaved, {
                        variant: 'success',
                    });
                    this.setState({
                        SubmitLoading:false,
                        open:false
                    });
                    this.props.reload()
                }else{
                    this.props.enqueueSnackbar(Translate.isbnIsExistHead, {
                        variant: 'warning',
                    });
                    this.setState({
                        SubmitLoading:false,
                    });
                }

            })
            .catch(error => {
                if(error.response.status === 404){
                    this.props.enqueueSnackbar(Translate.isbnIsExistHead, {
                        variant: 'warning',
                    });
                }else{
                    this.props.enqueueSnackbar(Translate.allChangesSavingFailed, {
                        variant: 'error',
                    });
                }

                this.setState({
                    errors:error.response.data,
                    SubmitLoading:false
                });
            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleFile(file){
        this.setState({
            file
        })
    }
    render(){
        let {SubmitLoading,open,fields,errors} = this.state;
        return (
            <>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => this.toggleOpen()}
                >
                    {Translate.addISBN}
                </Button>

                <Dialog
                    open={open}
                    onClose={() => this.toggleOpen()}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title">
                        <IconButton
                            onClick={() => this.toggleOpen()}
                            style={{position:"absolute",left:15,top:15}}
                            size="small"
                        >
                            <CloseRoundedIcon fontSize="small"/>
                        </IconButton>
                        {Translate.addISBNToProduct}
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    name="isbn"
                                    variant="outlined"
                                    label={Translate.isbn}
                                    placeholder={Translate.isbnHelper}
                                    type="number"
                                    id="isbn"
                                    value={fields.isbn}
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['isbn']}
                                    helperText={errors['isbn']}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    onClick = {this.handleSubmit.bind(this)}
                                    loading = {SubmitLoading}
                                >
                                    {Translate.save}
                                </LoadingButton>
                            </Grid>

                        </Grid>
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ExcelImportButton)))));